// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/icons-font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/icons-baloa2.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/reactions.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/Baloa-icons2.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/baloers.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/pollquiz.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../assets/fonts/HubIcons.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;700;800&family=Noto+Sans:wght@400;700&display=swap&family=Roboto:wght@100;300;400;500;700&display=swap&family=Poppins:wght@400;500;700;800&display=swap&family=Open+Sans:wght@400;500;700;800&display=swap&family=Libre+Baskerville:wght@400;500;700;800&display=swap&family=Quicksand:wght@400;500;700;800&display=swap&family=Lexend+Deca:wght@400;500;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Import Fonts */


/* Global Variables */

:root {

    /* Colors */
    
    --secondary-color: #00E063;
    /* --secondary-light-color: #65FF93;*/
    --secondary-light-color: #4AEA7C;    
    /* --secondary-dark-color: #00AD34; */
    --secondary-dark-color: #0C8D45;
    --background-light-color: #D8F6EB;
    --background-spring-sun-color:#FAFEDF;
    --basic-green-color: #00C256;    

    --primary-very-light-color: #F3FBF8;
    --primary-light-color: #D8E7E0;
    --primary-color: #94A89F; /*TODO: replace and delete*/
    --primary-dark-color: #4D5451;
    --primary-very-dark-color: #2A302A;

    /* --basic-gray-color: #71847B; */
    --basic-gray-color: #71847B;    
    /* --mid-gray-color: #AAC1B6; */
    --mid-gray-color: #AAC1B6;    


    --white-color: #FFFFFF;
    --error-color: #FF515B;
    --disabled-color: var(--mid-gray-color);    

    /* =====================
    NEW UI COLORS 
    ==================== */
    /* New new gray */
    --new-gray-color: #CDCDCD;

    /* New background light gray*/
    --new-light-gray-background-color: #FAFAFA;

    /* New Green */    
    --new-green-color: #30B36B;

    /* New Green dark */    
    --new-green-dark-color: #207848;

    /* gradient 2 */
    --new-green-gradient: linear-gradient(180deg, #00CA59 0%, #268A7E 100%);

    /* New_Background */
    --new-background-color:  #F3F5F7 ;

    /* New_Gray (inputs background)*/
    --new-gray-background-color: #E7E7E7;

    /* body background color */
    --body-background-color: #E5E5E5;

    /* separator color */
    --separator-color: #D8D8D8;

    /* disbled color */
    --new-gray-disabled-color: #C4C4C4;

    /* input background color */
    --new-input-background-color: #ECECEC;

    /* text buton color */
    --new-text-link-color: #3C3C3C;

    --black-color: #000000;

    /* New icon color*/
    --new-icon-color: #8999A8;

   /* New line color */
    --new-line-color: #DDDDDD;

   /* New template area color*/
    --new-template-area-color: #EDEDED;

    /* New warning color */
    --new-warning-color: #D1242E;

    /* New table header color */
    --new-table-header-color:#F7F7F7;

    --gray-color: #999999;

    --new-yellow-color: #FFA23D;

    --new-blue-color: #0052CC;

    --new-informative-banner-bg-color: #EDF2FC;

    --new-informative-banner-color: #1D5CC9;

    --new-yellow-warning-color: #F1FF51;

    --new-grey-light-background-color:#EEF1F9;

    --new-grey-border-color: #DDDEEB;
    
    /*====================*/


    /* Card colors */

    --bg-card-color : #FEFEFE;
    --border-card-color: #D8E7E0;

    /* Primary Button */

    --disabled-pb-bg-color: #F3FBF8;
    --disabled-pb-font-color: var(--disabled-color);
    --hover-pb-bg-color: #07FB73;
    --focused-pb-bg-color: #4BFF9B;
    --active-pb-bg-color: #00CC5A;

    /* Secondary Button */
    
    --disabled-sb-bg-color: transparent;
    --disabled-sb-font-color: #D8E7E0;
    --hover-sb-bg-color: #D9FFEA;
    --focused-sb-bg-color: #ABFFD0;
    --active-sb-bg-color: #4BFF9B;

    /* rounded button */
    --disabled-rb-bg-color: transparent;
    --disabled-rb-font-color: #D8E7E0;
    --hover-rb-bg-color: #ABFFD0;
    --focused-rb-bg-color: #ABFFD0;
    --active-rb-bg-color: #4BFF9B;

    /* Spaces */

    --space: 16px;
    --space-half: calc( var(--space) / 2 );
    --space-quarter: calc( var(--space) / 4 );
    --space-eighth: calc(var(--space)/8);
    --space-half-quarter: calc( var(--space-half) + var(--space-quarter) );
    --space-and-half: calc( var(--space) * 1.5 );
    --space-x2: calc( var(--space) * 2 );
    --space-x2-and-half: calc( var(--space-x2) + var(--space-half) );
    --space-x3: calc( var(--space) * 3 );

    /* Fonts */

    --primary-font: 'Barlow', sans-serif;
    /* --secondary-font: 'Noto Sans', sans-serif; */
    --secondary-font: 'Roboto', sans-serif;

    --font-regular: 400;
    --font-medium: 500;
    --font-bold: 700;
    --font-extra-bold: 800;

    --font-normal: var(--space);
    --font-small: var(--space-half-quarter);

    /* Shadows */

    --shadow: 0px 1px 5px 2px rgba(192, 208, 214, 0.33);
    --shadow-pb: 0px 1px 2px #A4BEB4;
    --shadow-hover-pb: 0px 1px 5px #3DA37A;
    --shadow-card-1: 0px 2px 5px rgba(170, 193, 182, 0.15), 0px 1px 12px rgba(192, 208, 214, 0.33);
    --shadow-card-2: 0px 1px 2px 1px rgba(170, 193, 182, 0.3), 0px 4px 12px 1px rgba(192, 208, 214, 0.33);
    --shadow-card-3: 0px 4px 12px 1px rgba(170, 193, 182, 0.3), 0px 8px 20px 1px rgba(192, 208, 214, 0.33);
    --shadow-card: 0px 1px 2px 1px rgba(170, 193, 182, 0.32), 0px 3px 12px 1px rgba(192, 208, 214, 0.67);

    /* Borders */

    --border: 8px solid var(--primary-light-color);
    --input-field-border: 2px solid var(--mid-gray-color);
    --input-field-border-focus: 2px solid var(--primary-dark-color);
    --input-field-border-error: 2px solid var(--error-color);

    /* Margins */

    --normal-margin-h: var(--space-and-half);
    --normal-margin-v: var(--space);
    --double-margin-h: var(--space-x2);
    --double-margin-v: var(--space-and-half);
    --wide-margin-h: var(--space-x2-and-half);
    --wide-margin-v: var(--space-x2);

    /* Grid */

    --grid-gap: var(--space-and-half);

}

/* Bigger vars */

@media screen and ( min-width: 1441px ) {

    :root {

        /* Spaces */

        --space: 18px;

    }

}

/* Desktop vars */

@media screen and ( max-width: 1440px ) {

    :root {

        /* Spaces */

        --space: 16px;

    }

}

/* Tablet vars */

@media screen and ( max-width: 992px ) {

    :root {

        /* Spaces */

        --space: 16px;

    }

}

/* Medium vars */

@media screen and ( max-width: 768px ) {

    :root {

        /* Spaces */

        --space: 15px;

    }
    
}

/* Mobile vars */

@media screen and ( max-width: 576px ) {
    
    :root {
        
        /* Spaces */
        
        --space: 14px;

        /* Margins */
        
        --normal-margin-h: var(--space);
        --normal-margin-v: var(--space);
        --double-margin-h: var(--space);
        --double-margin-v: var(--space);
        --wide-margin-h: var(--space);
        --wide-margin-v: var(--space);
        
    }

}


/* Defaults */

html {
    background: var(--new-background-color);
    font-size: var(--space);
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
}
body {
    background-color: var(--new-background-color) !important;
    height: 100%;
    zoom: 75%;
    overflow: auto;    
}

p, h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
}
h3 {
    font-size: var(--space-and-half) !important;
    font-family: var(--primary-font) !important;
    font-weight: var(--font-medium) !important;
    line-height: var(--space-x2);
    color: var(--primary-very-dark-color);
}
p {
    font-size: var(--font-normal);
    font-family: var(--secondary-font);
    font-weight: var(--font-regular);
    line-height: var(--space-and-half);
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
}
a {
    text-decoration: none;
}
#root {
    /* height: 100%; */
    background-color: var(--new-background-color);
}


/* OOCSS */

.view {
    /* background: var(--white-color); */
    height: 100%;
    /* box-shadow: 0px 1px 5px 2px rgba(192, 208, 214, 0.33) inset; */
    margin-top: 72px;
}

/* Se comenta media query para version web mobile */
/* @media screen and ( max-width: 576px ) {
    .view {
        padding: 0 var(--space);    
    }
}

 @media screen and (max-width: 768px){
    .view {
        margin-top: 130px;   
    }
} */

/* Utilities */

.link {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--font-small);
    color: var(--secondary-dark-color);
}

.text-alert {
    color: var(--error-color);
}

.form {
    width: 100%;
}
.form .form__fields .input-field:first-child {
    margin-top: 0;
}
.form .form__fields .input-field:last-child {
    margin-bottom: 0;
}
.form .form__actions {
    padding: var(--space) var(--space);
}

.hidden {
    display: none;
}

.text-bold {
    font-weight: var(--font-bold);
}

.scroll {
    overflow-y: scroll;
    position: relative;
}
.scroll-parent {
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
div[hidden].scroll-parent {
    display: none;
}

/* Mobile web media queries */
@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    :root {        
        /* Spaces */
        --space: 12px;
    }
    .view {
        margin-top: 56px;
    }
    body {
        zoom: 100%;
    }
}

/* Design system */

/* .baloa-headline-2 {
   
font-family: var(--primary-font);
font-size: calc(var(--space-x3) + var(--space-half));
font-style: normal;
font-weight: var(--font-bold);
line-height: calc(var(--space-x3) + var(--space-and-half));
letter-spacing: -0.005em;
text-align: center;


} */

.baloa-headline-3 {
    /* New_Headline 2 */
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space-and-half) + 1px);/* 25px */
    line-height: calc(var(--space-and-half) + var(--space-quarter) + 1px);/* 29px */
    letter-spacing: 0.0015em;
    color: var(--black-color);

/*     font-family: var(--primary-font);
    font-size: calc(var(--space-x2) + var(--space-half-quarter));
    font-style: normal;
    font-weight: var(--font-bold);
    line-height: calc(var(--space-x3) + var(--space-quarter));
    letter-spacing: -0.005em; */
}

.baloa-headline-4 {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space-x2) !important;
    line-height: var(--space-x3) !important;
    letter-spacing: 0.0025em !important;
    color: var(--mid-gray-color) !important;
}

.baloa-headline-5 {
    /* New_Subtitle 1 */
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/*22px*/
    line-height: calc(var(--space-and-half) + var(--space-eighth));/* 26px */
    letter-spacing: 0.0015em;
    color: var(--black-color);

    /* font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space-and-half) !important;
    line-height: calc( var(--space-and-half) + var(--space-quarter) ) !important;
    color: var(--primary-dark-color) !important; */
}

.baloa-headline-6 {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: calc( var(--space-and-half)  - var(--space-quarter) ) !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.015em !important;
    color: var(--primary-very-dark-color) !important;
}

.baloa-headline-7 {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space) !important;
    line-height: var(--space-and-half) !important;
    letter-spacing: 0.015em !important;
    color: var(--primary-very-dark-color) !important;
}

/* .baloa-subtitle-1 {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space) !important;
    line-height: 20px !important;
    align-items: center;
    letter-spacing: 0.0015em;
    color: var(--primary-very-dark-color) !important;
} */

/* .baloa-subtitle-2 {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space) !important;
    line-height: 18px !important;
    align-items: center;
    letter-spacing: 0.001em;
    color: var(--primary-dark-color) !important;
} */

.baloa-body-1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-normal);
    font-size: var(--space);
    line-height: calc( var(--space-and-half) - 2px );;
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
}

.baloa-body-2 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );/* 14px */
    line-height: calc( var(--space) + 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--basic-gray-color) !important;
}

.baloa-truncate {
    width: 7vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* body-bold */

.baloa-body-bold {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var( --font-bold) !important;
    font-size: var(--space);/*  16px */
    line-height: var( --space-and-half);
    display: flex;
    align-items: center;
    letter-spacing: 0.005em;
}

.baloa-caption {
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-normal);
    font-size: var(--space-half-quarter);
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color) !important;
}

.baloa-caption-dark {
    font-family: var(--secondary-font) !important;
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: var(--space-half-quarter);
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.004em;
    color: var(--basic-gray-color) !important;
}

.baloa-overlines{
    font-family: var(--secondary-font);
    font-size: calc(var(--space-half-quarter) - 2px);
    font-style: normal;
    font-weight: var(--font-regular);
    line-height: 14px;
    letter-spacing: 0.025em;
    text-align: left;
    color: var(--basic-gray-color);
    display: flex;
    align-items: center;
}


/* =====================
NEW UI FONTS 
==================== */

/* New_Normal Text */
.baloa-normal-text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Headline 1 */
.baloa-headline-1{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: calc( var(--space-x2) - var(--space-eighth) );/* 30px */
    line-height: calc(var(--space-x2) + var(--space-quarter));/* 36px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Headline 2 */
.baloa-headline-2{ /*override*/
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-half) + 1px);/* 25px */
    line-height: calc(var(--space) + var(--space-half) + var(--space-quarter) + 1px);/* 29px */
    letter-spacing: 0.0015em;
    color: var(--black-color);
}

/* New_Subtitle 1 */
.baloa-subtitle-1{ /*override*/
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    line-height: calc(var(--space) + var(--space-half) + var(--space-eighth));/* 26px */
    letter-spacing: 0.0015em;
    color: var(--black-color);
}

/* New_Subtitle 2 */
.baloa-subtitle-2{ /*override*/
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-quarter));/* 20px */;
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth) + 1px);/* 23px */
    letter-spacing: 0.0015em;
    color: var(--black-color);
}

/* New_Normal Text */
.baloa-normal{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Normal Text Medium */
.baloa-normal-medium{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Table Text */
.baloa-table{ 
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--space);/* 16px */
    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Hyperlink */
.baloa-hyperlink{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-bold);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Username Text */
.baloa-username{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */;
    line-height: var(--space);/* 16px */
    letter-spacing: 0.0025em; 
    color: var(--black-color);
}

/* New_Names Text */
.baloa-names{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);/*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    color: var(--black-color);
}

/* New_Table Column Names */
.baloa-table-column{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */
    line-height: calc(var(--space) + var(--space-eighth));/* 18px*/;
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

/* New_Hyperlink 2 */
.baloa-hyperlink-2{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-bold);
    font-size: var(--space);/* 16px */
    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

.baloa-mini{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half) + var(--space-quarter));/* 12px */
    line-height: calc(var(--space-half) + var(--space-quarter) + var(--space-eighth));/* 14px */
    letter-spacing: 0.0025em;
    color: var(--black-color);
}

span[color="1DA1F2"]{
    background: #1DA1F2;
}
span[color="F45D22"]{
    background: #F45D22;
}
span[color="17BF63"]{
    background: #17BF63;
}
span[color="FFAD1F"]{
    background: #FFAD1F;
}
span[color="8899A6"]{
    background: #8899A6;
}
span[color="794BC4"]{
    background: #794BC4;
}
span[color="E0245E"]{
    background: #E0245E;
}

/* 
======================
Material v5 Styles
====================== 
*/

.MuiButtonBase-root.MuiSwitch-colorSecondary.Mui-checked {
    color: var(--new-green-color);
}

.MuiButtonBase-root.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track{
    background-color:  var(--new-green-color);
    opacity: 0.5;
}

.MuiButtonBase-root.MuiCheckbox-root.MuiCheckbox-colorSecondary.Mui-checked {
    color: var(--new-green-color);
}

.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorSecondary.Mui-checked {
    color: var(--new-green-color);
}

.MuiFormControlLabel-asterisk {
    display: none;
}

.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {
    background-color: var(--secondary-light-color);
}

.MuiButtonBase-root.MuiMenuItem-root.Mui-selected:hover {
    background-color: var(--new-background-color);
}

.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected {
    color: var(--new-green-color);
    border-bottom: 3px solid var(--new-green-color);
}

.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary {
    color: var(--basic-gray-color);
    text-transform: none;
    font-size: var(--space);
}

.MuiTabs-root .MuiTabs-indicator {
    background-color: var(--new-green-color);
    height: 3px;
    display: none;
}

.MuiInputBase-root.MuiInput-root::before {
    border-bottom: none;
}

.MuiInputBase-root.MuiInput-root:hover:not(.Mui-disabled,.Mui-error):before {
    border-bottom: none;
}

.MuiFormControl-root .MuiFormLabel-root.Mui-focused {
    color: var(--new-green-color);
}

.MuiSnackbar-root .MuiButtonBase-root.MuiButton-root {
    color: var(--new-green-color);
}

.MuiFormControl-root .MuiFormHelperText-root.Mui-error {
    color: var(--error-color);
}

.MuiButtonBase-root.MuiRadio-root.Mui-checked {
    color: var(--new-green-color);
}`, "",{"version":3,"sources":["webpack://./src/shared/styles/main.css"],"names":[],"mappings":";AACA,iBAAiB;;;AAYjB,qBAAqB;;AAErB;;IAEI,WAAW;;IAEX,0BAA0B;IAC1B,qCAAqC;IACrC,gCAAgC;IAChC,qCAAqC;IACrC,+BAA+B;IAC/B,iCAAiC;IACjC,qCAAqC;IACrC,4BAA4B;;IAE5B,mCAAmC;IACnC,8BAA8B;IAC9B,wBAAwB,EAAE,2BAA2B;IACrD,6BAA6B;IAC7B,kCAAkC;;IAElC,iCAAiC;IACjC,2BAA2B;IAC3B,+BAA+B;IAC/B,yBAAyB;;;IAGzB,sBAAsB;IACtB,sBAAsB;IACtB,uCAAuC;;IAEvC;;0BAEsB;IACtB,iBAAiB;IACjB,yBAAyB;;IAEzB,6BAA6B;IAC7B,0CAA0C;;IAE1C,cAAc;IACd,0BAA0B;;IAE1B,mBAAmB;IACnB,+BAA+B;;IAE/B,eAAe;IACf,uEAAuE;;IAEvE,mBAAmB;IACnB,iCAAiC;;IAEjC,gCAAgC;IAChC,oCAAoC;;IAEpC,0BAA0B;IAC1B,gCAAgC;;IAEhC,oBAAoB;IACpB,0BAA0B;;IAE1B,kBAAkB;IAClB,kCAAkC;;IAElC,2BAA2B;IAC3B,qCAAqC;;IAErC,qBAAqB;IACrB,8BAA8B;;IAE9B,sBAAsB;;IAEtB,kBAAkB;IAClB,yBAAyB;;GAE1B,mBAAmB;IAClB,yBAAyB;;GAE1B,2BAA2B;IAC1B,kCAAkC;;IAElC,sBAAsB;IACtB,4BAA4B;;IAE5B,2BAA2B;IAC3B,gCAAgC;;IAEhC,qBAAqB;;IAErB,2BAA2B;;IAE3B,yBAAyB;;IAEzB,0CAA0C;;IAE1C,uCAAuC;;IAEvC,mCAAmC;;IAEnC,yCAAyC;;IAEzC,gCAAgC;;IAEhC,uBAAuB;;;IAGvB,gBAAgB;;IAEhB,yBAAyB;IACzB,4BAA4B;;IAE5B,mBAAmB;;IAEnB,+BAA+B;IAC/B,+CAA+C;IAC/C,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;;IAE7B,qBAAqB;;IAErB,mCAAmC;IACnC,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;;IAE7B,mBAAmB;IACnB,mCAAmC;IACnC,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;;IAE7B,WAAW;;IAEX,aAAa;IACb,sCAAsC;IACtC,yCAAyC;IACzC,oCAAoC;IACpC,sEAAsE;IACtE,4CAA4C;IAC5C,oCAAoC;IACpC,gEAAgE;IAChE,oCAAoC;;IAEpC,UAAU;;IAEV,oCAAoC;IACpC,+CAA+C;IAC/C,sCAAsC;;IAEtC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;;IAEtB,2BAA2B;IAC3B,uCAAuC;;IAEvC,YAAY;;IAEZ,mDAAmD;IACnD,gCAAgC;IAChC,sCAAsC;IACtC,8FAA8F;IAC9F,qGAAqG;IACrG,sGAAsG;IACtG,oGAAoG;;IAEpG,YAAY;;IAEZ,8CAA8C;IAC9C,qDAAqD;IACrD,+DAA+D;IAC/D,wDAAwD;;IAExD,YAAY;;IAEZ,wCAAwC;IACxC,+BAA+B;IAC/B,kCAAkC;IAClC,wCAAwC;IACxC,yCAAyC;IACzC,gCAAgC;;IAEhC,SAAS;;IAET,iCAAiC;;AAErC;;AAEA,gBAAgB;;AAEhB;;IAEI;;QAEI,WAAW;;QAEX,aAAa;;IAEjB;;AAEJ;;AAEA,iBAAiB;;AAEjB;;IAEI;;QAEI,WAAW;;QAEX,aAAa;;IAEjB;;AAEJ;;AAEA,gBAAgB;;AAEhB;;IAEI;;QAEI,WAAW;;QAEX,aAAa;;IAEjB;;AAEJ;;AAEA,gBAAgB;;AAEhB;;IAEI;;QAEI,WAAW;;QAEX,aAAa;;IAEjB;;AAEJ;;AAEA,gBAAgB;;AAEhB;;IAEI;;QAEI,WAAW;;QAEX,aAAa;;QAEb,YAAY;;QAEZ,+BAA+B;QAC/B,+BAA+B;QAC/B,+BAA+B;QAC/B,+BAA+B;QAC/B,6BAA6B;QAC7B,6BAA6B;;IAEjC;;AAEJ;;;AAGA,aAAa;;AAEb;IACI,uCAAuC;IACvC,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,wDAAwD;IACxD,YAAY;IACZ,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,0CAA0C;IAC1C,4BAA4B;IAC5B,qCAAqC;AACzC;AACA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gCAAgC;IAChC,kCAAkC;IAClC,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,6CAA6C;AACjD;;;AAGA,UAAU;;AAEV;IACI,oCAAoC;IACpC,YAAY;IACZ,iEAAiE;IACjE,gBAAgB;AACpB;;AAEA,mDAAmD;AACnD;;;;;;;;;;GAUG;;AAEH,cAAc;;AAEd;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;;AAEA,6BAA6B;AAC7B,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,UAAU;IACd;AACJ;;AAEA,kBAAkB;;AAElB;;;;;;;;;;;GAWG;;AAEH;IACI,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,4CAA4C,CAAC,SAAS;IACtD,qEAAqE,CAAC,SAAS;IAC/E,wBAAwB;IACxB,yBAAyB;;AAE7B;;;;;+BAK+B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;IACrC,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,0CAA0C;IAC1C,0EAA0E,CAAC,OAAO;IAClF,8DAA8D,CAAC,SAAS;IACxE,wBAAwB;IACxB,yBAAyB;;IAEzB;;;;;kDAK8C;AAClD;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,2EAA2E;IAC3E,6CAA6C;IAC7C,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;IAClC,6CAA6C;IAC7C,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;;;;;;;;;GASG;;AAEH;;;;;;;;;GASG;;AAEH;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,uBAAuB;IACvB,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC,CAAC,SAAS;IAC/C,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,cAAc;;AAEd;IACI,kCAAkC;IAClC,kBAAkB;IAClB,yCAAyC;IACzC,uBAAuB,CAAC,UAAU;IAClC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,+BAA+B;IAC/B,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,gDAAgD;IAChD,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;;AAGA;;sBAEsB;;AAEtB,oBAAoB;AACpB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,wDAAwD,CAAC,SAAS;IAClE,yDAAyD,CAAC,SAAS;IACnE,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB,mBAAmB,WAAW;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,uDAAuD,CAAC,SAAS;IACjE,gFAAgF,CAAC,SAAS;IAC1F,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB,mBAAmB,WAAW;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,0EAA0E,CAAC,SAAS;IACpF,yEAAyE,CAAC,SAAS;IACnF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB,mBAAmB,WAAW;IAC1B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,oDAAoD,CAAC,SAAS;IAC9D,kFAAkF,CAAC,SAAS;IAC5F,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB,CAAC,SAAS;IACjC,2DAA2D,CAAC,SAAS;IACrE,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,6BAA6B;IAC7B,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,gEAAgE,CAAC,SAAS;IAC1E,yBAAyB,CAAC,SAAS;IACnC,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;IAC3C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,sEAAsE,CAAC,SAAS;IAChF,qDAAqD,CAAC,QAAQ;IAC9D,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,kCAAkC;IAClC,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB,CAAC,SAAS;IACjC,2DAA2D,CAAC,SAAS;IACrE,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,yDAAyD,CAAC,SAAS;IACnE,iFAAiF,CAAC,SAAS;IAC3F,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;;;;CAIC;;AAED;IACI,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,+CAA+C;AACnD;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["\n/* Import Fonts */\n\n@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;700;800&family=Noto+Sans:wght@400;700&display=swap&family=Roboto:wght@100;300;400;500;700&display=swap&family=Poppins:wght@400;500;700;800&display=swap&family=Open+Sans:wght@400;500;700;800&display=swap&family=Libre+Baskerville:wght@400;500;700;800&display=swap&family=Quicksand:wght@400;500;700;800&display=swap&family=Lexend+Deca:wght@400;500;700;800&display=swap');\n@import url(\"../../assets/fonts/icons-font.css\");\n@import url(\"../../assets/fonts/icons-baloa2.css\");\n@import url(\"../../assets/fonts/reactions.css\");\n@import url(\"../../assets/fonts/Baloa-icons2.css\");\n@import url(\"../../assets/fonts/baloers.css\");\n@import url(\"../../assets/fonts/pollquiz.css\");\n@import url(\"../../assets/fonts/HubIcons.css\");\n\n\n/* Global Variables */\n\n:root {\n\n    /* Colors */\n    \n    --secondary-color: #00E063;\n    /* --secondary-light-color: #65FF93;*/\n    --secondary-light-color: #4AEA7C;    \n    /* --secondary-dark-color: #00AD34; */\n    --secondary-dark-color: #0C8D45;\n    --background-light-color: #D8F6EB;\n    --background-spring-sun-color:#FAFEDF;\n    --basic-green-color: #00C256;    \n\n    --primary-very-light-color: #F3FBF8;\n    --primary-light-color: #D8E7E0;\n    --primary-color: #94A89F; /*TODO: replace and delete*/\n    --primary-dark-color: #4D5451;\n    --primary-very-dark-color: #2A302A;\n\n    /* --basic-gray-color: #71847B; */\n    --basic-gray-color: #71847B;    \n    /* --mid-gray-color: #AAC1B6; */\n    --mid-gray-color: #AAC1B6;    \n\n\n    --white-color: #FFFFFF;\n    --error-color: #FF515B;\n    --disabled-color: var(--mid-gray-color);    \n\n    /* =====================\n    NEW UI COLORS \n    ==================== */\n    /* New new gray */\n    --new-gray-color: #CDCDCD;\n\n    /* New background light gray*/\n    --new-light-gray-background-color: #FAFAFA;\n\n    /* New Green */    \n    --new-green-color: #30B36B;\n\n    /* New Green dark */    \n    --new-green-dark-color: #207848;\n\n    /* gradient 2 */\n    --new-green-gradient: linear-gradient(180deg, #00CA59 0%, #268A7E 100%);\n\n    /* New_Background */\n    --new-background-color:  #F3F5F7 ;\n\n    /* New_Gray (inputs background)*/\n    --new-gray-background-color: #E7E7E7;\n\n    /* body background color */\n    --body-background-color: #E5E5E5;\n\n    /* separator color */\n    --separator-color: #D8D8D8;\n\n    /* disbled color */\n    --new-gray-disabled-color: #C4C4C4;\n\n    /* input background color */\n    --new-input-background-color: #ECECEC;\n\n    /* text buton color */\n    --new-text-link-color: #3C3C3C;\n\n    --black-color: #000000;\n\n    /* New icon color*/\n    --new-icon-color: #8999A8;\n\n   /* New line color */\n    --new-line-color: #DDDDDD;\n\n   /* New template area color*/\n    --new-template-area-color: #EDEDED;\n\n    /* New warning color */\n    --new-warning-color: #D1242E;\n\n    /* New table header color */\n    --new-table-header-color:#F7F7F7;\n\n    --gray-color: #999999;\n\n    --new-yellow-color: #FFA23D;\n\n    --new-blue-color: #0052CC;\n\n    --new-informative-banner-bg-color: #EDF2FC;\n\n    --new-informative-banner-color: #1D5CC9;\n\n    --new-yellow-warning-color: #F1FF51;\n\n    --new-grey-light-background-color:#EEF1F9;\n\n    --new-grey-border-color: #DDDEEB;\n    \n    /*====================*/\n\n\n    /* Card colors */\n\n    --bg-card-color : #FEFEFE;\n    --border-card-color: #D8E7E0;\n\n    /* Primary Button */\n\n    --disabled-pb-bg-color: #F3FBF8;\n    --disabled-pb-font-color: var(--disabled-color);\n    --hover-pb-bg-color: #07FB73;\n    --focused-pb-bg-color: #4BFF9B;\n    --active-pb-bg-color: #00CC5A;\n\n    /* Secondary Button */\n    \n    --disabled-sb-bg-color: transparent;\n    --disabled-sb-font-color: #D8E7E0;\n    --hover-sb-bg-color: #D9FFEA;\n    --focused-sb-bg-color: #ABFFD0;\n    --active-sb-bg-color: #4BFF9B;\n\n    /* rounded button */\n    --disabled-rb-bg-color: transparent;\n    --disabled-rb-font-color: #D8E7E0;\n    --hover-rb-bg-color: #ABFFD0;\n    --focused-rb-bg-color: #ABFFD0;\n    --active-rb-bg-color: #4BFF9B;\n\n    /* Spaces */\n\n    --space: 16px;\n    --space-half: calc( var(--space) / 2 );\n    --space-quarter: calc( var(--space) / 4 );\n    --space-eighth: calc(var(--space)/8);\n    --space-half-quarter: calc( var(--space-half) + var(--space-quarter) );\n    --space-and-half: calc( var(--space) * 1.5 );\n    --space-x2: calc( var(--space) * 2 );\n    --space-x2-and-half: calc( var(--space-x2) + var(--space-half) );\n    --space-x3: calc( var(--space) * 3 );\n\n    /* Fonts */\n\n    --primary-font: 'Barlow', sans-serif;\n    /* --secondary-font: 'Noto Sans', sans-serif; */\n    --secondary-font: 'Roboto', sans-serif;\n\n    --font-regular: 400;\n    --font-medium: 500;\n    --font-bold: 700;\n    --font-extra-bold: 800;\n\n    --font-normal: var(--space);\n    --font-small: var(--space-half-quarter);\n\n    /* Shadows */\n\n    --shadow: 0px 1px 5px 2px rgba(192, 208, 214, 0.33);\n    --shadow-pb: 0px 1px 2px #A4BEB4;\n    --shadow-hover-pb: 0px 1px 5px #3DA37A;\n    --shadow-card-1: 0px 2px 5px rgba(170, 193, 182, 0.15), 0px 1px 12px rgba(192, 208, 214, 0.33);\n    --shadow-card-2: 0px 1px 2px 1px rgba(170, 193, 182, 0.3), 0px 4px 12px 1px rgba(192, 208, 214, 0.33);\n    --shadow-card-3: 0px 4px 12px 1px rgba(170, 193, 182, 0.3), 0px 8px 20px 1px rgba(192, 208, 214, 0.33);\n    --shadow-card: 0px 1px 2px 1px rgba(170, 193, 182, 0.32), 0px 3px 12px 1px rgba(192, 208, 214, 0.67);\n\n    /* Borders */\n\n    --border: 8px solid var(--primary-light-color);\n    --input-field-border: 2px solid var(--mid-gray-color);\n    --input-field-border-focus: 2px solid var(--primary-dark-color);\n    --input-field-border-error: 2px solid var(--error-color);\n\n    /* Margins */\n\n    --normal-margin-h: var(--space-and-half);\n    --normal-margin-v: var(--space);\n    --double-margin-h: var(--space-x2);\n    --double-margin-v: var(--space-and-half);\n    --wide-margin-h: var(--space-x2-and-half);\n    --wide-margin-v: var(--space-x2);\n\n    /* Grid */\n\n    --grid-gap: var(--space-and-half);\n\n}\n\n/* Bigger vars */\n\n@media screen and ( min-width: 1441px ) {\n\n    :root {\n\n        /* Spaces */\n\n        --space: 18px;\n\n    }\n\n}\n\n/* Desktop vars */\n\n@media screen and ( max-width: 1440px ) {\n\n    :root {\n\n        /* Spaces */\n\n        --space: 16px;\n\n    }\n\n}\n\n/* Tablet vars */\n\n@media screen and ( max-width: 992px ) {\n\n    :root {\n\n        /* Spaces */\n\n        --space: 16px;\n\n    }\n\n}\n\n/* Medium vars */\n\n@media screen and ( max-width: 768px ) {\n\n    :root {\n\n        /* Spaces */\n\n        --space: 15px;\n\n    }\n    \n}\n\n/* Mobile vars */\n\n@media screen and ( max-width: 576px ) {\n    \n    :root {\n        \n        /* Spaces */\n        \n        --space: 14px;\n\n        /* Margins */\n        \n        --normal-margin-h: var(--space);\n        --normal-margin-v: var(--space);\n        --double-margin-h: var(--space);\n        --double-margin-v: var(--space);\n        --wide-margin-h: var(--space);\n        --wide-margin-v: var(--space);\n        \n    }\n\n}\n\n\n/* Defaults */\n\nhtml {\n    background: var(--new-background-color);\n    font-size: var(--space);\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    overflow-x: hidden;\n    -webkit-font-smoothing: antialiased;\n}\nbody {\n    background-color: var(--new-background-color) !important;\n    height: 100%;\n    zoom: 75%;\n    overflow: auto;    \n}\n\np, h1, h2, h3, h4, h5, h6 {\n    margin: 0;\n    padding: 0;\n}\nh3 {\n    font-size: var(--space-and-half) !important;\n    font-family: var(--primary-font) !important;\n    font-weight: var(--font-medium) !important;\n    line-height: var(--space-x2);\n    color: var(--primary-very-dark-color);\n}\np {\n    font-size: var(--font-normal);\n    font-family: var(--secondary-font);\n    font-weight: var(--font-regular);\n    line-height: var(--space-and-half);\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n}\na {\n    text-decoration: none;\n}\n#root {\n    /* height: 100%; */\n    background-color: var(--new-background-color);\n}\n\n\n/* OOCSS */\n\n.view {\n    /* background: var(--white-color); */\n    height: 100%;\n    /* box-shadow: 0px 1px 5px 2px rgba(192, 208, 214, 0.33) inset; */\n    margin-top: 72px;\n}\n\n/* Se comenta media query para version web mobile */\n/* @media screen and ( max-width: 576px ) {\n    .view {\n        padding: 0 var(--space);    \n    }\n}\n\n @media screen and (max-width: 768px){\n    .view {\n        margin-top: 130px;   \n    }\n} */\n\n/* Utilities */\n\n.link {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--font-small);\n    color: var(--secondary-dark-color);\n}\n\n.text-alert {\n    color: var(--error-color);\n}\n\n.form {\n    width: 100%;\n}\n.form .form__fields .input-field:first-child {\n    margin-top: 0;\n}\n.form .form__fields .input-field:last-child {\n    margin-bottom: 0;\n}\n.form .form__actions {\n    padding: var(--space) var(--space);\n}\n\n.hidden {\n    display: none;\n}\n\n.text-bold {\n    font-weight: var(--font-bold);\n}\n\n.scroll {\n    overflow-y: scroll;\n    position: relative;\n}\n.scroll-parent {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\ndiv[hidden].scroll-parent {\n    display: none;\n}\n\n/* Mobile web media queries */\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    :root {        \n        /* Spaces */\n        --space: 12px;\n    }\n    .view {\n        margin-top: 56px;\n    }\n    body {\n        zoom: 100%;\n    }\n}\n\n/* Design system */\n\n/* .baloa-headline-2 {\n   \nfont-family: var(--primary-font);\nfont-size: calc(var(--space-x3) + var(--space-half));\nfont-style: normal;\nfont-weight: var(--font-bold);\nline-height: calc(var(--space-x3) + var(--space-and-half));\nletter-spacing: -0.005em;\ntext-align: center;\n\n\n} */\n\n.baloa-headline-3 {\n    /* New_Headline 2 */\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space-and-half) + 1px);/* 25px */\n    line-height: calc(var(--space-and-half) + var(--space-quarter) + 1px);/* 29px */\n    letter-spacing: 0.0015em;\n    color: var(--black-color);\n\n/*     font-family: var(--primary-font);\n    font-size: calc(var(--space-x2) + var(--space-half-quarter));\n    font-style: normal;\n    font-weight: var(--font-bold);\n    line-height: calc(var(--space-x3) + var(--space-quarter));\n    letter-spacing: -0.005em; */\n}\n\n.baloa-headline-4 {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space-x2) !important;\n    line-height: var(--space-x3) !important;\n    letter-spacing: 0.0025em !important;\n    color: var(--mid-gray-color) !important;\n}\n\n.baloa-headline-5 {\n    /* New_Subtitle 1 */\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/*22px*/\n    line-height: calc(var(--space-and-half) + var(--space-eighth));/* 26px */\n    letter-spacing: 0.0015em;\n    color: var(--black-color);\n\n    /* font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space-and-half) !important;\n    line-height: calc( var(--space-and-half) + var(--space-quarter) ) !important;\n    color: var(--primary-dark-color) !important; */\n}\n\n.baloa-headline-6 {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: calc( var(--space-and-half)  - var(--space-quarter) ) !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.015em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n.baloa-headline-7 {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space) !important;\n    line-height: var(--space-and-half) !important;\n    letter-spacing: 0.015em !important;\n    color: var(--primary-very-dark-color) !important;\n}\n\n/* .baloa-subtitle-1 {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space) !important;\n    line-height: 20px !important;\n    align-items: center;\n    letter-spacing: 0.0015em;\n    color: var(--primary-very-dark-color) !important;\n} */\n\n/* .baloa-subtitle-2 {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space) !important;\n    line-height: 18px !important;\n    align-items: center;\n    letter-spacing: 0.001em;\n    color: var(--primary-dark-color) !important;\n} */\n\n.baloa-body-1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-normal);\n    font-size: var(--space);\n    line-height: calc( var(--space-and-half) - 2px );;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n}\n\n.baloa-body-2 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );/* 14px */\n    line-height: calc( var(--space) + 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--basic-gray-color) !important;\n}\n\n.baloa-truncate {\n    width: 7vw;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* body-bold */\n\n.baloa-body-bold {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var( --font-bold) !important;\n    font-size: var(--space);/*  16px */\n    line-height: var( --space-and-half);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.005em;\n}\n\n.baloa-caption {\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-normal);\n    font-size: var(--space-half-quarter);\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color) !important;\n}\n\n.baloa-caption-dark {\n    font-family: var(--secondary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: var(--space-half-quarter);\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.004em;\n    color: var(--basic-gray-color) !important;\n}\n\n.baloa-overlines{\n    font-family: var(--secondary-font);\n    font-size: calc(var(--space-half-quarter) - 2px);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    line-height: 14px;\n    letter-spacing: 0.025em;\n    text-align: left;\n    color: var(--basic-gray-color);\n    display: flex;\n    align-items: center;\n}\n\n\n/* =====================\nNEW UI FONTS \n==================== */\n\n/* New_Normal Text */\n.baloa-normal-text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Headline 1 */\n.baloa-headline-1{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 600;\n    font-size: calc( var(--space-x2) - var(--space-eighth) );/* 30px */\n    line-height: calc(var(--space-x2) + var(--space-quarter));/* 36px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Headline 2 */\n.baloa-headline-2{ /*override*/\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-half) + 1px);/* 25px */\n    line-height: calc(var(--space) + var(--space-half) + var(--space-quarter) + 1px);/* 29px */\n    letter-spacing: 0.0015em;\n    color: var(--black-color);\n}\n\n/* New_Subtitle 1 */\n.baloa-subtitle-1{ /*override*/\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    line-height: calc(var(--space) + var(--space-half) + var(--space-eighth));/* 26px */\n    letter-spacing: 0.0015em;\n    color: var(--black-color);\n}\n\n/* New_Subtitle 2 */\n.baloa-subtitle-2{ /*override*/\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-quarter));/* 20px */;\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth) + 1px);/* 23px */\n    letter-spacing: 0.0015em;\n    color: var(--black-color);\n}\n\n/* New_Normal Text */\n.baloa-normal{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Normal Text Medium */\n.baloa-normal-medium{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Table Text */\n.baloa-table{ \n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--space);/* 16px */\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Hyperlink */\n.baloa-hyperlink{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-bold);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Username Text */\n.baloa-username{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */;\n    line-height: var(--space);/* 16px */\n    letter-spacing: 0.0025em; \n    color: var(--black-color);\n}\n\n/* New_Names Text */\n.baloa-names{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);/*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    color: var(--black-color);\n}\n\n/* New_Table Column Names */\n.baloa-table-column{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);/* 15px */\n    line-height: calc(var(--space) + var(--space-eighth));/* 18px*/;\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n/* New_Hyperlink 2 */\n.baloa-hyperlink-2{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-bold);\n    font-size: var(--space);/* 16px */\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\n.baloa-mini{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half) + var(--space-quarter));/* 12px */\n    line-height: calc(var(--space-half) + var(--space-quarter) + var(--space-eighth));/* 14px */\n    letter-spacing: 0.0025em;\n    color: var(--black-color);\n}\n\nspan[color=\"1DA1F2\"]{\n    background: #1DA1F2;\n}\nspan[color=\"F45D22\"]{\n    background: #F45D22;\n}\nspan[color=\"17BF63\"]{\n    background: #17BF63;\n}\nspan[color=\"FFAD1F\"]{\n    background: #FFAD1F;\n}\nspan[color=\"8899A6\"]{\n    background: #8899A6;\n}\nspan[color=\"794BC4\"]{\n    background: #794BC4;\n}\nspan[color=\"E0245E\"]{\n    background: #E0245E;\n}\n\n/* \n======================\nMaterial v5 Styles\n====================== \n*/\n\n.MuiButtonBase-root.MuiSwitch-colorSecondary.Mui-checked {\n    color: var(--new-green-color);\n}\n\n.MuiButtonBase-root.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track{\n    background-color:  var(--new-green-color);\n    opacity: 0.5;\n}\n\n.MuiButtonBase-root.MuiCheckbox-root.MuiCheckbox-colorSecondary.Mui-checked {\n    color: var(--new-green-color);\n}\n\n.MuiButtonBase-root.MuiRadio-root.MuiRadio-colorSecondary.Mui-checked {\n    color: var(--new-green-color);\n}\n\n.MuiFormControlLabel-asterisk {\n    display: none;\n}\n\n.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {\n    background-color: var(--secondary-light-color);\n}\n\n.MuiButtonBase-root.MuiMenuItem-root.Mui-selected:hover {\n    background-color: var(--new-background-color);\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected {\n    color: var(--new-green-color);\n    border-bottom: 3px solid var(--new-green-color);\n}\n\n.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary {\n    color: var(--basic-gray-color);\n    text-transform: none;\n    font-size: var(--space);\n}\n\n.MuiTabs-root .MuiTabs-indicator {\n    background-color: var(--new-green-color);\n    height: 3px;\n    display: none;\n}\n\n.MuiInputBase-root.MuiInput-root::before {\n    border-bottom: none;\n}\n\n.MuiInputBase-root.MuiInput-root:hover:not(.Mui-disabled,.Mui-error):before {\n    border-bottom: none;\n}\n\n.MuiFormControl-root .MuiFormLabel-root.Mui-focused {\n    color: var(--new-green-color);\n}\n\n.MuiSnackbar-root .MuiButtonBase-root.MuiButton-root {\n    color: var(--new-green-color);\n}\n\n.MuiFormControl-root .MuiFormHelperText-root.Mui-error {\n    color: var(--error-color);\n}\n\n.MuiButtonBase-root.MuiRadio-root.Mui-checked {\n    color: var(--new-green-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
